
import { Vue, Component } from 'vue-property-decorator';
import Icon from '@/components/Icons/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class Dismiss extends Vue {
  isMobile = false;
  windowSize = {
    width: 0,
    height: 0,
  };

  onResize() {
    this.isMobile = this.windowSize.width < 960;
  }
}
